// Function to handle checkbox functionality
function handleCheckboxFunctionality() {
  // Find all cart product cards with ATC checkboxes
  const cartProductCards = document.querySelectorAll('.cart-product-card');
  
  cartProductCards.forEach(card => {
    const checkbox = card.querySelector('.atc_checkbox');
    const productForm = card.querySelector('product-form form');
    
    if (checkbox && productForm) {
      // Get the product ID from the cart product card
      const productId = card.getAttribute('data-product-id');
      const cartItems = document.querySelectorAll('.line-item');
      let isInCart = false;

      cartItems.forEach(item => {
        const itemProductId = item.getAttribute('data-product-id');
        if (itemProductId === productId) {
          isInCart = true;
        }
      });

      // Set checkbox state based on cart
      checkbox.checked = isInCart;

      // Add change event listener
      checkbox.addEventListener('change', function() {
        if (this.checked) {
          // Find the submit button in the form
          const submitButton = productForm.querySelector('button[type="submit"]');
          if (submitButton) {
            submitButton.click();
          }
        } else {
          // Find the related line item and click its remove button
          cartItems.forEach(item => {
            const itemProductId = item.getAttribute('data-product-id');
            if (itemProductId === productId) {
              const removeButton = item.querySelector('.remove_line_item');
              if (removeButton) {
                removeButton.click();
              }
            }
          });
        }
      });
    }
  });
}

// Initial call when DOM is loaded
document.addEventListener('DOMContentLoaded', handleCheckboxFunctionality);

// Create a MutationObserver to watch for changes in the cart drawer
const observer = new MutationObserver(function(mutations) {
  mutations.forEach(function(mutation) {
    if (mutation.addedNodes.length) {
      // Check if the cart drawer content was updated
      const cartDrawer = document.querySelector('cart-drawer');
      if (cartDrawer && mutation.target.contains(cartDrawer)) {
        // Small delay to ensure all elements are rendered
        setTimeout(handleCheckboxFunctionality, 100);
      }
    }
  });
});

// Start observing the document body for changes
observer.observe(document.body, {
  childList: true,
  subtree: true
}); 